import { ProfileImageMedia } from "@client/content/controls/Media/component";
import { type Leaderboard } from "@client/content/modules/Leaderboard/types";
import * as React from "react";

import "./style.less";

type Props = {
  item: Leaderboard.Item;
  size: number;
};
export default ({ item, size }: Props) => (
  <div className="wsc_leaderboard_profile_image">
    <ProfileImageMedia
      sourceId={item.profilePictureSourceId}
      sourceKey={item.profilePictureMediaSourceKey}
      email={item.email}
      firstName={item.firstName}
      lastName={item.lastName}
      size={size}
    />
  </div>
);
